module.exports = __webpack_public_path__ + "media/base/vendor_truck_small-657dea48.svg";